import { useState } from 'react';

import { FileMimeTypeEnum } from '../../lib/enums';
import { createBase64DataUrl } from '../../lib/util/DataHelpers';

import { logoSources } from '../../util/customLogos';

import styles from './CompanyLogo.module.scss';

type Props = {
  logo?: string;
  url?: string;
  className?: string;
  symbol?: string;
}

const CompanyLogo = ({ logo, url, className, symbol }: Props): JSX.Element => {
  // TODO: Remove this after the task ART-3903 is done. This is a temporary solution.
  const customLogoSource = symbol ? logoSources[symbol] : null;
  const [errored, setErrored] = useState(false);
  const [urlFailed, setUrlFailed] = useState(false);

  const fallbackLogoStyle = logo
    ? { backgroundImage: `url(${createBase64DataUrl(logo, FileMimeTypeEnum.Jpeg)})` }
    : undefined;

  if (customLogoSource) {
    return (
      <div>
        {!errored ? (
          <img
            className={[styles.logo, className].join(' ')}
            src={customLogoSource}
            alt=""
            onError={() => setErrored(true)}
          />
        ) : (
          <div className={[styles.logo, className].join(' ')} />
        )}
      </div>
    );
  }

  if (url && url.trim() !== '' && !urlFailed) {
    return (
      <img
        className={[styles.logo, className].join(' ')}
        src={url}
        alt=""
        onError={() => setUrlFailed(true)}
      />
    );
  }

  return (
    <div
      className={[styles.logo, className].join(' ')}
      style={fallbackLogoStyle}
    />
  );
};

export default CompanyLogo;
